import { IconButton, styled } from '@mui/material';

export const MyIconButton = styled(IconButton)(() => ({
  '&:focus': {
    outline: 'none',
  },
}));
